<template>
  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.5 0C4.70138 0 0 4.70138 0 10.5C0 16.2986 4.70138 21 10.5 21C16.2986 21 21 16.2986 21 10.5C21 4.70138 16.2986 0 10.5 0ZM10.5 19.25C5.67525 19.25 1.75 15.3247 1.75 10.5C1.75 5.67525 5.67525 1.75 10.5 1.75C15.3247 1.75 19.25 5.67525 19.25 10.5C19.25 15.3247 15.3247 19.25 10.5 19.25Z"
      fill="currentColor" />
    <path
      d="M7 6.125C6.03312 6.125 5.25 6.90812 5.25 7.875C5.25 8.84188 6.03312 9.625 7 9.625C7.96688 9.625 8.75 8.84188 8.75 7.875C8.75 6.90812 7.96688 6.125 7 6.125Z"
      fill="currentColor" />
    <path
      d="M14 6.125C13.0331 6.125 12.25 6.90812 12.25 7.875C12.25 8.84188 13.0331 9.625 14 9.625C14.9669 9.625 15.75 8.84188 15.75 7.875C15.75 6.90812 14.9669 6.125 14 6.125Z"
      fill="currentColor" />
    <path
      d="M13.328 13.125C12.7216 14.1706 11.6918 14.875 10.3976 14.875C9.10525 14.875 8.0745 14.1706 7.469 13.125H13.125H13.328ZM15.75 11.375H5.25C5.25 14.2747 7.60025 16.625 10.5 16.625C13.3997 16.625 15.75 14.2747 15.75 11.375Z"
      fill="currentColor" />
  </svg>
</template>
